export const mapObjToFormData = <T>(obj: Record<string, T>) => {
  const data = new FormData();
  Object.entries(obj).forEach(([key, value]) => {
    const isFilelist = value instanceof FileList;
    if (isFilelist) {
      Array.from(value).forEach((file) => data.append(key, file));
    } else {
      data.append(key, value as string);
    }
  });
  return data;
};

export const isObjectSubset = <T extends object>(
  object: T,
  subset: Partial<T>,
) =>
  Object.entries(subset).every(
    ([key, value]) => object[key as keyof T] === value,
  );
